import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import { isHighSchoolUrl, isHighSchoolDashboard } from 'utils/highschoolHelpers'
import {
  isDigitalWellBeingUrl,
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
  isK5Url,
  isK5Dashboard,
} from 'utils/productHelpers'

import OffComponent from './flag.off'
import OnComponent from './flag.on'

export {
  DefaultSiteSelectorWrapper,
  SiteSelectorK8WrapperDark,
  SiteSelectorK8WrapperLight,
} from './component.styles'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    const isHighSchool = isHighSchoolUrl() || isHighSchoolDashboard()

    const isMiddleSchool = isMiddleSchoolUrl() || isMiddleSchoolDashboard()

    const isK5 =
      (isK5Url() || isK5Dashboard()) &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isHighSchool || isMiddleSchool || isK5 || isDigitalWellBeingUrl()
  },
})

export default FlagToggler
